export default "__VITE_ASSET__522efcda__"